import React from 'react';

import AthleteListActionBanner from './AthleteListActionBanner';

interface IPaymentInfoRequestBannerProps {
  count: number;
  onReview: () => void;
}

const PaymentInfoRequestBanner = ({ count, onReview }: IPaymentInfoRequestBannerProps): JSX.Element => (
  <AthleteListActionBanner
    message={`${count} ${
      count === 1 ? 'athlete is' : 'athletes are'
    } eligible to receive a payment request.`}
    actionLabel='Review and send request'
    onAction={onReview}
    bannerDataCy='paymentInfoRequestBanner'
    buttonDataCy='reviewPaymentInfoRequestBtn'
  />
);

export default PaymentInfoRequestBanner;
